import { Fragment } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { AuthProvider } from "./context/Auth/AuthContext";
import { ConfigContextProvider } from "./context/Config/ConfigContext";
import { CartContextProvider } from "./context/Cart/CartContext";
import { FilterContextProvider } from "./context/FilterContext/FilterContext";
import { ProductsContextProvider } from "./context/Products/ProductsContext";
import Navbar from "./containers/Navbar";
import HomeContainer from "./containers/HomeContainer";
import LoginContainer from "./containers/LoginContainer";
import AccountCreationFormContainer from "./containers/AccountCreationFormContainer";
import ItemDetailContainer from "./containers/ItemDetailContainer";
import ItemsListContainer from "./containers/ItemsListContainer";
import AddressShippingContainer from "./containers/AddressShippingContainer";
import CartContainer from "./containers/CartContainer";
import MyAccountContainer from "./containers/MyAccountContainer";
import OrdersContainer from "./containers/OrdersContainer";
import FooterContainer from "./containers/FooterContainer/FooterContainer";
import OrderDetailContainer from "./containers/OrderDetailContainer";
import PayMethodsContainer from "./containers/PayMethodsContainer/PayMethodsContainer";
import CheckoutContainer from "./containers/CheckoutContainer";
import PendingOrders from "./components/PendingOrders";
import ClosedOrders from "./components/ClosedOrders";
import ProtectedRoutes from "./containers/ProtectedRoutes";
import theme from "./assets/monacoTheme";
import SideCart from "./containers/Sidecart/Sidecart";
import FooterInformationContainer from "./containers/FooterInformationContainer/FooterInformationContainer";
import MyData from "./components/MyData/MyData";
import AddAddressContainer from "./containers/AddAddressContainer";
import EditAddressContainer from "./containers/EditAddressContainer";
import PasswordRequestFormContainer from "./containers/PasswordRequestFormContainer/PasswordRequestFormContainer";
import PasswordChangeContainer from "./containers/PasswordChangeContainer/PasswordChangeContainer";
import "./App.css";

function App() {
	return (
		<ThemeProvider theme={theme}>
			<BrowserRouter>
				<AuthProvider>
					<ConfigContextProvider>
						<CartContextProvider>
							<ProductsContextProvider>
								<FilterContextProvider>
									<Routes>
										<Route
											exact
											path="/login"
											element={<LoginContainer />}
										></Route>
										<Route
											exact
											path="/new-password-request"
											element={<PasswordRequestFormContainer />}
										></Route>
										<Route
											exact
											path="/create-user"
											element={<AccountCreationFormContainer />}
										></Route>
										<Route
											path="/"
											element={
												<Fragment>
													<Navbar />
													<HomeContainer />
													<FooterContainer />
												</Fragment>
											}
										></Route>
										<Route
											path="/home"
											element={
												<Fragment>
													<Navbar />
													<HomeContainer />
													<FooterContainer />
												</Fragment>
											}
										></Route>

										<Route
											exact
											path="/information"
											element={
												<Fragment>
													<Navbar />
													<FooterInformationContainer />
													<FooterContainer />
												</Fragment>
											}
										></Route>

										<Route
											exact
											path="/user-account"
											element={
												<ProtectedRoutes>
													<MyAccountContainer />
												</ProtectedRoutes>
											}
										></Route>

										<Route
											exact
											path="/user-account/orders"
											element={
												<ProtectedRoutes>
													<Fragment>
														<OrdersContainer />
														<FooterContainer />
													</Fragment>
												</ProtectedRoutes>
											}
										>
											<Route path="pending" element={<PendingOrders />} />
											<Route path="closed" element={<ClosedOrders />} />
										</Route>
										<Route
											exact
											path="/user-account/data"
											element={
												<ProtectedRoutes>
													<Fragment>
														<MyData />
														<FooterContainer />
													</Fragment>
												</ProtectedRoutes>
											}
										></Route>
										<Route
											exact
											path="/user-account/password-change"
											element={
												<ProtectedRoutes>
													<Fragment>
														<PasswordChangeContainer />
														<FooterContainer />
													</Fragment>
												</ProtectedRoutes>
											}
										></Route>
										<Route
											exact
											path="/user-account/address-shipping"
											element={
												<ProtectedRoutes>
													<Fragment>
														<AddressShippingContainer />
														<FooterContainer />
													</Fragment>
												</ProtectedRoutes>
											}
										></Route>
										<Route
											exact
											path="/user-account/address-shipping/edit-addres"
											element={
												<ProtectedRoutes>
													<Fragment>
														<EditAddressContainer />
														<FooterContainer />
													</Fragment>
												</ProtectedRoutes>
											}
										></Route>
										<Route
											exact
											path="/user-account/address-shipping/new-address"
											element={
												<ProtectedRoutes>
													<Fragment>
														<AddAddressContainer />
														<FooterContainer />
													</Fragment>
												</ProtectedRoutes>
											}
										></Route>
										<Route
											exact
											path="/user-account/orders/:orderId"
											element={
												<ProtectedRoutes>
													<Fragment>
														<OrderDetailContainer />
														<FooterContainer />
													</Fragment>
												</ProtectedRoutes>
											}
										/>
										<Route
											path="/user-account/pay-methods"
											element={
												<ProtectedRoutes>
													<PayMethodsContainer />
												</ProtectedRoutes>
											}
										></Route>
										<Route
											exact
											path="/category/:categoryId"
											element={
												<Fragment>
													<Navbar />
													<ItemsListContainer />
													<FooterContainer />
												</Fragment>
											}
										/>
										<Route
											exact
											path="/category/:categoryId/:subcategoryId"
											element={
												<Fragment>
													<Navbar />
													<ItemsListContainer />
													<FooterContainer />
												</Fragment>
											}
										/>
										<Route
											exact
											path="/search/:productsSearched"
											element={
												<Fragment>
													<Navbar />
													<ItemsListContainer />
													<FooterContainer />
												</Fragment>
											}
										></Route>
										<Route
											exact
											path="/itemDetail/:idProduct"
											element={
												<Fragment>
													<Navbar />
													<ItemDetailContainer />
													<FooterContainer />
												</Fragment>
											}
										></Route>
										<Route
											exact
											path="/cart"
											element={
												<ProtectedRoutes>
													<CartContainer />
												</ProtectedRoutes>
											}
										/>
										<Route
											exact
											path="/cart/checkout"
											element={
												<ProtectedRoutes>
													<CheckoutContainer />
												</ProtectedRoutes>
											}
										/>
									</Routes>
									<SideCart />
								</FilterContextProvider>
							</ProductsContextProvider>
						</CartContextProvider>
					</ConfigContextProvider>
				</AuthProvider>
			</BrowserRouter>
		</ThemeProvider>
	);
}

export default App;
